
export default {
  'zh-CN': {
    imageSizeLimit: '图片大小要小于{n}',
    uploadError: '网络错误,请重新上传',
    imageUploadingRules: '最多只允许上传{m}张图片，已上传{n}张，还能再上传{s}张'
  },
  'en': {
    imageSizeLimit: 'The image size should be less than {n}',
    uploadError: 'Network error, please upload again',
    imageUploadingRules: 'Only {m} pictures can be uploaded at most. {n} pictures have been uploaded, and another {s} pictures can be uploaded'
  },
  'ja': {
    imageSizeLimit: '图片大小要小于{n}',
    uploadError: '网络错误,请重新上传',
    imageUploadingRules: '最多只允许上传{m}张图片，已上传{n}张，还能再上传{s}张'
  }
}
